/**
 * @readonly
 * @enum {string}
 */
export const ObjectTypes = Object.freeze({
    APE: 'ape',
    BARGE: 'barge',
    BIKE: 'bike',
    BOOM_LIFT: 'boom_lift',
    BOOM_LIFT_TRUCK: 'boom_lift_truck',
    BUS: 'bus',
    CADDY: 'caddy',
    CAR: 'car',
    CAR_STATION_WAGON: 'car_station_wagon',
    CONCRETE_LORRY: 'concrete_lorry',
    CONTAINER_SHIP: 'containership',
    CRANE: 'crane',
    DEPOSIT_TIPPER: 'deposit_tipper',
    DUMP_TRUCK: 'dump_truck',
    DUMP_TRUCK_OPEN: 'dump_truck_open',
    EXCAVATOR: 'excavator',
    GARBAGE_TRUCK: 'garbage_truck',
    HEAVY_TRUCK: 'heavy_truck',
    HEAVY_TRUCK_US: 'heavytruck_us',
    HEAVY_WEIGHT_TRUCK: 'heavyweight_truck',
    HEAVY_WEIGHT_TRUCK_TRAILER: 'heavyweight_truck_trailer',
    LIGHT_TRUCK: 'lighttruck',
    LIGHT_TRUCK_PALLET: 'light_truck_pallet',
    LOADER: 'loader',
    MEDIUM_TRUCK: 'medium_truck',
    MULTI_CAR: 'multicar',
    MULTI_VAN: 'multivan',
    PALLET_TRUCK: 'pallet_truck',
    PICKUP: 'pickup',
    SMART: 'smart',
    SPRINTER: 'sprinter',
    STREET_SWEEPER: 'street_sweeper',
    SUV: 'suv',
    TANKER_TRUCK: 'tanker_truck',
    TELESCOPIC_HANDLER: 'telescopic_handler',
    TRACTOR: 'tractor',
    TRAILER: 'trailer',
    TRAIN: 'train',
    TRUCK: 'truck',
    TRUCK_LOADER_ARM: 'truck_loader_arm',
    TRUCK_TRAILER: 'truck_trailer',
    TRUCK_WITH_TRAILER: 'truck_with_trailer',
    TRUCK_WRECKER: 'truck_wrecker',
    VAN: 'van',
    VESPA: 'vespa',
    WRECKER: 'wrecker',
    YACHT: 'yacht',
    AMBULANCE: 'ambulance',
    FIRETRUCK: 'firetruck',
    POLICE: 'police',
    TAXI: 'taxi',
    TAXI_UK: 'taxi_uk',
    ECO_PLUS: 'ecoPLUS',
    LINK_100: 'link100',
    LINK_510: 'link510',
    LINK_610: 'link610',
    LINK_710: 'link710',
    LINK: 'link',
    PHONE: 'phone',
    TABLET: 'tablet'
})
